import Request from "../data/request";


export default class ApiView {

    static createView(payload: any) {
        return new Request(this, 'POST', 'saved-view/create', payload);
    }

    static getView(id: ID) {
        return new Request(this,'GET','saved-view/'+id);
    }

    static deleteView(id: ID) {
        return new Request(this,'DELETE','saved-view/'+id);
    }

    static updateView(id: ID, payload: any) {
        return new Request(this,'PUT','saved-view/'+id, payload);
    }

    static udsViews(payload: any) {
        return new Request(this, 'POST', 'uds/saved-views', payload);
    }

}
